import classnames from 'classnames';
import React from 'react';

import { withStyles } from 'src/app/helpers/styles';
import { IconClose } from 'src/app/components/Icon/IconClose';
import { ButtonIcon } from '../Button/ButtonIcon';

interface MyProps {
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  isFullScreen?: boolean;
}

@withStyles(require('./PopupContainer.scss'))
export class PopupContainer extends React.Component<MyProps> {
  render(): JSX.Element {
    const { children, onClick, isFullScreen } = this.props;
    return (
      <div className={classnames('position-fixed top-0 bottom-0 left-0 right-0 popup-container', isFullScreen ? 'bg-black' : 'popup-container-background')} onClick={onClick}>
        {
          isFullScreen &&
          <ButtonIcon modifier='transparent' className='position-fixed right-0' classNameIcon='fg-gray' icon={IconClose}/>
        }
        {children}
      </div>
    );
  }
}
